import { CruiseItineraryFragment } from "types/graphql-types";

export enum ShorexCategory {
  IncludedInAllInclusive,
  Premium,
  MidVoyageLandAdventure
}

export type CategorisedShorex = RemoteShorex & {
  displayCategory?: ShorexCategory;
  duration: number;
  hideDurationAndCode: boolean;
};

export type RemoteShorex = {
  _id?: string;
  shorexId?: number;
  name?: string;
  activityLevel?: number;
  accessibility?: string;
  features?: string[];
  portId?: string;
  code?: string;
  category: string;
};

export type RemoteLandProgramme = {
  _id?: string;
  landProgrammeId?: number;
  name?: string;
  portId?: string;
  code?: string;
};

export type RemoteExcursion = RemoteLandProgramme | RemoteShorex;

export type RemoteConfirmedExcursions = {
  portId: string;
  itineraryItem: string;
  shorexes: RemoteConfirmedShorexList;
  confirmedLandProgrammeIds: RemoteConfirmedLandProgrammeList;
};

export type RemoteConfirmedShorexList = {
  _key: number;
  includedInAllInclusive: boolean;
  shorexId: number;
  duration: number;
}[];
export type RemoteConfirmedLandProgrammeList = number[];

export type RemoteConfirmedShorexPerItineraryItem = RemoteConfirmedShorexList;
export type RemoteRemoteConfirmedLandProgrammeListPerItineraryItem = RemoteConfirmedLandProgrammeList;

export type RemoteConfirmedExcursionsPerItineraryItem = {
  confirmedShorexes: RemoteConfirmedShorexList;
  confirmedLandProgrammes: RemoteRemoteConfirmedLandProgrammeListPerItineraryItem;
};

export type RemoteGetExcursionsQueryResponse = {
  shorexes: RemoteShorex[];
  landProgrammes: RemoteLandProgramme[];
  confirmedExcursions: RemoteConfirmedExcursions[];
};

export interface CruiseItineraryItemWithExcursions
  extends CruiseItineraryFragment {
  shorexes: CategorisedShorex[];
  landProgrammes: RemoteLandProgramme[];
}
